// extracted by mini-css-extract-plugin
module.exports = {"icon":"icon__NYEin","interactive":"interactive__3S_y0","colored":"colored__39XdT","coloredHover":"coloredHover__uwytW","disabled":"disabled__2QBIN"};